import { useEffect } from 'react';

export const useDetectOutside = (ref, callback) => {
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        callback();
      }
    };

    const handleWindowBlur = () => {
      // Small delay to allow focus to settle
      setTimeout(() => {
        // Check if focus moved to an iframe or any element outside our ref
        if (document.activeElement) {
          if (
            ref.current &&
            !ref.current.contains(document.activeElement)
          ) {
            callback();
          }
        } else {
          // If no active element, also consider it an outside click
          callback();
        }
      }, 0);
    };

    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener('blur', handleWindowBlur);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('blur', handleWindowBlur);
    };
  }, [ref, callback]);
};
